module.exports = __webpack_public_path__ + "static/media/Entreprise-Construction-Immobilier-Vaud.8a6c409d.jpg";